// The 11 official South African languages. `code` doubles as the locale file
// name (public/locales/<code>.json), the localStorage value, and the
// document lang attribute. Sepedi has no ISO 639-1 code, so its 639-2 code
// (nso) is used — everything downstream treats codes as opaque strings.
export const SUPPORTED_LANGUAGES = [
  { code: "en", nativeName: "English" },
  { code: "af", nativeName: "Afrikaans" },
  { code: "nr", nativeName: "isiNdebele" },
  { code: "nso", nativeName: "Sepedi" },
  { code: "st", nativeName: "Sesotho" },
  { code: "ss", nativeName: "siSwati" },
  { code: "tn", nativeName: "Setswana" },
  { code: "ts", nativeName: "Xitsonga" },
  { code: "ve", nativeName: "Tshivenḓa" },
  { code: "xh", nativeName: "isiXhosa" },
  { code: "zu", nativeName: "isiZulu" },
] as const;

export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number]["code"];

export const DEFAULT_LANGUAGE: LanguageCode = "en";

export function isLanguageCode(value: unknown): value is LanguageCode {
  return SUPPORTED_LANGUAGES.some((lang) => lang.code === value);
}

/** First browser-preferred language we support, else English. Matches on the
 * primary subtag only ("zu-ZA" → "zu") — region variants aren't distinguished. */
export function detectBrowserLanguage(): LanguageCode {
  for (const tag of navigator.languages ?? [navigator.language]) {
    const base = tag?.toLowerCase().split("-")[0];
    if (isLanguageCode(base)) return base;
  }
  return DEFAULT_LANGUAGE;
}
